import type { IconSvgObject } from './types';

const JoinStraightIcon: IconSvgObject = [
  ["path", { d: "M22.0001 13.0001V22.0001H2.00009V2.00012H11.0001V13.0001H22.0001Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default JoinStraightIcon;
